(function () {
  'use strict';

  const { BaseCarousel } = window.Universe;

  class AnnouncementBar {
    constructor() {
      this.init();
    }

    reinit() {
      this.destroy();
      this.init();
    }

    setup() {
      if (this.DOM.carousel) {
        // With autoplay off, arrows + drag are the only way to advance the slides.
        const autoplay = 'autoplay' in this.DOM.carousel.dataset;

        this.carouselInstance = new BaseCarousel({
          wrap: this.DOM.carousel,
          carouselOptions: {
            align: 'center',
            loop: true,
            watchDrag: !autoplay,
          },
          withAutoScroll: false,
          withAutoPlay: autoplay,
          onReady: () => {
            if (!this.carouselInstance.instance) return;
            if (this.DOM.carouselAnnouncement) {
              this.carouselInstance.instance.on('select', () => {
                this.announceCarouselSlide();
              });
            }
            this.bindNav();
          },
        });
      }

      this.setupCountdowns();
    }

    bindNav() {
      const embla = this.carouselInstance && this.carouselInstance.instance;
      if (!embla) return;

      this.onPrev = () => embla.scrollPrev();
      this.onNext = () => embla.scrollNext();
      this.DOM.prev.forEach((btn) => btn.addEventListener('click', this.onPrev));
      this.DOM.next.forEach((btn) => btn.addEventListener('click', this.onNext));
    }

    setupCountdowns() {
      if (!this.DOM.countdowns || !this.DOM.countdowns.length) return;

      this.countdownTimers = [];
      this.DOM.countdowns.forEach((el) => this.initCountdown(el));
    }

    initCountdown(el) {
      const target = new Date(el.dataset.isodate).getTime();
      if (isNaN(target)) return;

      const s = window.accessibilityStrings || {};
      const content = el.querySelector('.js-countdown-content');
      const endLabel = el.dataset.endLabel;
      const onEnd = el.dataset.onEnd;

      const units = {
        days: { el: el.querySelector('.js-days'), suffix: s.countdownDays || '', ms: 86400000 },
        hours: { el: el.querySelector('.js-hours'), suffix: s.countdownHours || '', ms: 3600000 },
        minutes: { el: el.querySelector('.js-minutes'), suffix: s.countdownMinutes || '', ms: 60000 },
        seconds: { el: el.querySelector('.js-seconds'), suffix: s.countdownSeconds || '', ms: 1000 },
      };

      const paint = (values) => {
        Object.keys(units).forEach((key) => {
          const unit = units[key];
          if (unit.el) unit.el.innerHTML = String(values[key]).padStart(2, '0') + unit.suffix;
        });
      };

      // Returns true once the countdown has ended, so the caller can stop ticking.
      const render = () => {
        let diff = target - Date.now();
        if (diff <= 0) {
          if (onEnd === 'hide') {
            this.removeSlide(el);
          } else if (onEnd === 'message' && endLabel && content) {
            content.textContent = endLabel;
          } else {
            paint({ days: 0, hours: 0, minutes: 0, seconds: 0 });
          }
          return true;
        }

        const values = {};
        Object.keys(units).forEach((key) => {
          values[key] = Math.floor(diff / units[key].ms);
          diff %= units[key].ms;
        });
        paint(values);
        return false;
      };

      if (render()) return;

      const timer = window.setInterval(() => {
        if (render()) window.clearInterval(timer);
      }, 1000);
      this.countdownTimers.push(timer);
    }

    // The countdown element is the slide itself; remove it and let Embla
    // re-measure. If the carousel hasn't initialized yet, the slide is simply
    // gone from the DOM before init reads it.
    removeSlide(slide) {
      slide.remove();
      const embla = this.carouselInstance && this.carouselInstance.instance;
      if (embla) embla.reInit();
    }

    announceCarouselSlide() {
      if (!this.DOM.carouselAnnouncement || !this.carouselInstance || !this.carouselInstance.instance) return;

      const currentSlide = this.carouselInstance.instance.selectedScrollSnap() + 1;
      const totalSlides = this.carouselInstance.instance.scrollSnapList().length;
      const label = this.DOM.carouselAnnouncement.dataset.label || 'Announcement [current] of [total]';
      this.DOM.carouselAnnouncement.textContent = label.replace('[current]', currentSlide).replace('[total]', totalSlides);
    }

    destroy() {
      if (this.DOM) {
        if (this.onPrev) this.DOM.prev.forEach((btn) => btn.removeEventListener('click', this.onPrev));
        if (this.onNext) this.DOM.next.forEach((btn) => btn.removeEventListener('click', this.onNext));
        this.onPrev = undefined;
        this.onNext = undefined;

        if (this.carouselInstance) {
          this.carouselInstance.destroy();
          this.carouselInstance = undefined;
        }
        if (this.countdownTimers) {
          this.countdownTimers.forEach((timer) => window.clearInterval(timer));
          this.countdownTimers = undefined;
        }
        this.DOM = undefined;
      }
    }

    init(container = document) {
      const wrap = container.querySelector('.js-announcement-bar');

      if (wrap) {
        this.DOM = {};
        this.DOM.wrap = wrap;
        this.DOM.carousel = this.DOM.wrap.querySelector('.js-announcement-bar-carousel');
        this.DOM.carouselAnnouncement = this.DOM.wrap.querySelector('.js-announcement-carousel-announcement');
        this.DOM.countdowns = this.DOM.wrap.querySelectorAll('.js-announcement-countdown');
        this.DOM.prev = this.DOM.wrap.querySelectorAll('.js-carousel-prev');
        this.DOM.next = this.DOM.wrap.querySelectorAll('.js-carousel-next');

        this.carouselInstance = undefined;
        this.countdownTimers = undefined;

        this.setup();
      }
    }
  }

  window.Universe.AnnouncementBar = AnnouncementBar;
})();
